export const newsList = [
  {
    id: 'news-1',
    title: '《我妻子的一切》片场花絮：一场雨戏拍了整整三天',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20film%20set%20at%20night%20with%20rain%20machines%20and%20warm%20amber%20studio%20lights%2C%20camera%20and%20lighting%20equipment%20in%20the%20foreground%2C%20deep%20navy%20tones%2C%20wet%20ground%20reflections%2C%20no%20people%20faces%2C%20no%20text%2C%20documentary%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape',
    date: '2026-10-08',
    excerpt: '为了还原剧中那场关键的雨夜重逢，剧组连续三个通宵淋着人工雨拍摄，主演林晚晴笑称“妆比人还先下班”。',
    body: [
      '“这场雨戏，我们拍了整整三天。”在《我妻子的一切》的片场，导演陈立航指着监视器说。为了拍到雨丝在暖黄路灯下最漂亮的那一帧，美术组反复调整了洒水车与灯位，主演们则在深秋的夜里一遍遍走位。',
      '饰演许知夏的林晚晴透露，最难的不是淋雨，而是要在雨里演出那种“明明有很多话却一句都说不出”的克制。“导演要求特别细，连睫毛上的水珠停留多久都算进去了。”',
      '剧组工作人员表示，这场戏最终会成为全剧的重要转折点。“观众看到的不只是雨，而是两个人之间那道终于被冲开的墙。”据了解，该场戏将出现在第11集《真相的前一秒》中。',
    ],
    tags: ['片场花絮', '幕后', '我妻子的一切'],
    relatedDramaId: 'wo-qizi-de-yi-qie',
  },
  {
    id: 'news-2',
    title: '《春日迟迟》温暖收官，主创发文告别角色',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20empty%20old%20bookstore%20interior%20with%20wooden%20shelves%20and%20amber%20afternoon%20light%20through%20the%20window%2C%20dust%20particles%20and%20soft%20bokeh%2C%20nostalgic%20hopeful%20mood%2C%20no%20people%2C%20no%20text%2C%20documentary%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-02&orientation=landscape',
    date: '2026-09-20',
    excerpt: '随着大结局上线，《春日迟迟》正式收官。主演夏未在社交平台写下长文告别“苏晚”这个角色，感谢整个春天的陪伴。',
    body: [
      '《春日迟迟》上线以来口碑一路上扬，被观众称为“今年最治愈的一部剧”。6集的故事里，没有大起大落，只有一个小镇、一家旧书店和两个慢慢靠近的人。',
      '主演夏未发文写道：“苏晚让我学会了慢下来。谢谢这个春天，谢谢每一个陪我们走到最后的人。”饰演陈屿的程屿则晒出了片场那把旧椅子，配文只有两个字：“再会。”',
      '据制作方透露，剧组正在筹备一段未播出的番外片段，预计将在近期与观众见面。',
    ],
    tags: ['剧集收官', '春日迟迟', '主创动态'],
    relatedDramaId: 'spring-late',
  },
  {
    id: 'news-3',
    title: '《无声的证词》幕后：道具组如何还原一间真实解剖室',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20crime%20drama%20with%20a%20recreated%20forensic%20laboratory%20set%20in%20cold%20blue%20light%2C%20glass%20instruments%20and%20files%20on%20tables%2C%20warm%20desk%20lamp%20accent%2C%20no%20people%2C%20no%20text%2C%20documentary%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape',
    date: '2026-10-02',
    excerpt: '为了让法医戏份经得起推敲，《无声的证词》剧组请来专业顾问，从器械摆放到灯光都以真实解剖室为蓝本。',
    body: [
      '在悬疑剧里，氛围往往比台词更重要。《无声的证词》的美术团队花了两个月时间，参照真实法医工作环境，一比一搭建了剧中的解剖室。',
      '道具组负责人介绍，光是那排不锈钢器械就定制了三套：“我们希望观众一眼看过去，会相信这里真的发生过什么。”冷色调的主光与一盏暖色台灯形成了剧中最经典的画面对比。',
      '主演白露透露，开拍前她专门跟随法医顾问学习了基础流程，“演顾清的时候，我脑子里想的不是‘我在演戏’，而是‘我必须弄明白这具尸体在说什么’。”',
    ],
    tags: ['幕后制作', '无声的证词', '美术道具'],
    relatedDramaId: 'wu-sheng-de-zheng-ci',
  },
  {
    id: 'news-4',
    title: '专访《长夜将尽》导演韦澈：悬疑之外，我更想讲人心',
    cover: 'https://readdy.ai/api/search-image?query=Interview%20setting%20on%20an%20empty%20film%20set%20at%20dusk%20with%20a%20director%20chair%20and%20warm%20amber%20light%20against%20deep%20navy%20backdrop%2C%20camera%20equipment%20blurred%2C%20quiet%20thoughtful%20mood%2C%20no%20people%2C%20no%20text%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape',
    date: '2026-09-30',
    excerpt: '《长夜将尽》开播后，导演韦澈接受了我们的专访，聊了聊他为什么不满足于“讲一个漂亮的悬疑故事”。',
    body: [
      '“如果只是破案，那这个故事五分钟就讲完了。”韦澈说。对他而言，《长夜将尽》真正想拍的是那些被时间困住的人——他们不是凶手，也不是受害者，却同样被困在那通打错的电话里。',
      '谈到那场著名的“山路夜戏”，韦澈回忆，为了等一场真正的雾，剧组在山里住了三天。“特效可以做雾，但做不出那种冷，演员也没法真的害怕。”',
      '当被问到结局，他笑而不答，只说了一句：“长夜会尽，但有些人愿意一直留在夜里，是因为那里有他放不下的东西。”',
    ],
    tags: ['导演专访', '长夜将尽', '创作谈'],
    relatedDramaId: 'chang-ye-jiang-jin',
  },
  {
    id: 'news-5',
    title: '《迷雾追凶》取景地曝光，这座小镇藏着多少故事',
    cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20foggy%20mountain%20town%20street%20at%20dawn%20with%20cold%20blue%20mist%20and%20warm%20window%20lights%2C%20old%20stone%20houses%20and%20quiet%20lanes%2C%20no%20people%2C%20no%20text%2C%20documentary%20photography%2C%20high%20detail%2C%20editorial%20composition&width=800&height=500&seq=news-cover-05&orientation=landscape',
    date: '2026-09-25',
    excerpt: '跟着《迷雾追凶》的镜头，我们走访了剧组的实景取景地。清晨的浓雾、石板路和老宅，构成了这部剧最难忘的气质。',
    body: [
      '《迷雾追凶》最打动人的，除了层层递进的悬念，还有那种挥之不去的雾。剧组没有依赖特效，而是选择了一座海拔较高、常年有雾的山间小镇实景拍摄。',
      '“我们每天凌晨四点就要上山，因为只有那半个小时，雾是最漂亮的。”摄影指导说。为了留住真实的光线，很多镜头都是一条过的。',
      '镇上的居民也成了剧组的“编外演员”。那位在剧里默默看着老宅的老人，其实就是住在这里几十年的原住户。',
    ],
    tags: ['取景地', '迷雾追凶', '拍摄纪实'],
    relatedDramaId: 'mi-wu-zhui-xiong',
  },
  {
    id: 'news-6',
    title: '《山海情书》主题曲上线，海边拍摄花絮首度公开',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20on%20a%20rocky%20seaside%20cliff%20at%20golden%20hour%20with%20deep%20blue%20sea%2C%20film%20camera%20and%20tripod%20on%20the%20rocks%2C%20warm%20sunlight%2C%20wind%20and%20waves%2C%20no%20people%20faces%2C%20no%20text%2C%20documentary%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-06&orientation=landscape',
    date: '2026-10-04',
    excerpt: '《山海情书》同名主题曲正式上线，随歌曲曝光的还有一组海边拍摄花絮，记录了剧组在风浪里坚持取景的瞬间。',
    body: [
      '“写信的人已经不在了，可海还在。”这是《山海情书》主题曲里最让人难忘的一句歌词。歌曲上线当天，就登上了多个音乐平台的热搜。',
      '随歌曲公开的花絮里，可以看到剧组在礁石上顶着大风架设设备。工作人员说，海岛天气多变，为了拍到那束夕阳打在信纸上的光，他们等了整整五天。',
      '制片人表示，主题曲的旋律在剧本阶段就已经写下雏形，“我们想让它听起来像一封没有寄出的信，温柔，但带着一点遗憾。”',
    ],
    tags: ['主题曲', '山海情书', '音乐'],
    relatedDramaId: 'shan-hai-qing-shu',
  },
  {
    id: 'news-7',
    title: '《岁月知味》美食特辑：剧里的每道菜都是真实烹饪',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20kitchen%20scene%20with%20fresh%20ingredients%20and%20steaming%20dishes%20on%20a%20wooden%20table%2C%20amber%20lighting%2C%20hanging%20herbs%20blurred%20in%20background%2C%20appetizing%20nostalgic%20mood%2C%20no%20people%2C%20no%20text%2C%20food%20photography%2C%20high%20detail&width=800&height=500&seq=news-cover-07&orientation=landscape',
    date: '2026-09-18',
    excerpt: '在《岁月知味》中，几乎没有一道菜是“道具”。剧组坚持每一道登场的菜都真材实料、现场烹饪，连香气都是真的。',
    body: [
      '很多美食剧里的菜只是“看起来好吃”，但《岁月知味》偏不。剧组请来真正的老厨师坐镇，剧里出现的每一道菜，都是开拍前现做现拍。',
      '“香味骗不了人。”主演林小满说，“拍的时候整个片场都是香的，导演喊卡之后大家第一件事就是抢着吃。”',
      '为了让“失传的配方”那场戏更真实，厨师团队还专门复原了一道几乎失传的地方菜。制片人透露，后续会考虑推出正式的食谱特辑。',
    ],
    tags: ['美食特辑', '岁月知味', '幕后'],
    relatedDramaId: 'sui-yue-zhi-wei',
  },
  {
    id: 'news-8',
    title: '《心上月光》主演专访：青春里的那束月光',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20rooftop%20at%20night%20with%20a%20full%20moon%2C%20deep%20navy%20sky%20and%20warm%20string%20lights%2C%20city%20skyline%20softly%20blurred%20below%2C%20quiet%20romantic%20mood%2C%20no%20people%2C%20no%20text%2C%20editorial%20photography%2C%20high%20detail%2C%20cinematic%20composition&width=800&height=500&seq=news-cover-08&orientation=landscape',
    date: '2026-10-03',
    excerpt: '《心上月光》开播后，两位主演聊了聊他们眼中的青春、约定，以及那个在天台上一起看月亮的夜晚。',
    body: [
      '“那场天台戏，我们其实拍了两个版本。”主演夏栀说，一个是剧本写好的，一个是导演临时让他们自由发挥的。“最后用的是自由发挥的那条，因为更真。”',
      '饰演顾星野的演员则坦言，自己学生时代也有过一个没说出口的约定，“所以演的时候，我一直在想，如果当时勇敢一点会怎样。”',
      '两位主演还透露，拍摄期间的天台其实是真实楼顶，月亮也是当晚真实的月亮。“那种光，打灯是打不出来的。”',
    ],
    tags: ['主演专访', '心上月光', '青春'],
    relatedDramaId: 'xin-shang-yue-guang',
  },
];